export default "__VITE_ASSET__CYO3F9a4__"